import { Link, useParams } from "react-router-dom";
import LazyImage from "../components/LazyImage";
import { getGalleryImage } from "../data/galleryImages";

/** Strict, so "/view/12abc" is a miss rather than silently resolving to 12. */
const parseGalleryNumber = (value: string | undefined): number =>
  value !== undefined && /^\d+$/.test(value) ? Number(value) : Number.NaN;

const View = () => {
  const { number } = useParams<{ number: string }>();
  const image = getGalleryImage(parseGalleryNumber(number));

  // The old fallback pointed at via.placeholder.com, a domain that no longer
  // resolves, so a bad number rendered a broken image.
  if (!image) {
    return (
      <div className="p-10 text-center">
        <h1 className="title romanStandard text-sm">Image not found</h1>
        <p className="romanStandard pb-5">We couldn’t find that design.</p>
        <Link className="romanStandard underline" to="/gallery">
          Back to the gallery
        </Link>
      </div>
    );
  }

  return (
    <Link to="/gallery" aria-label="Back to the gallery">
      <div className="px-20">
        <LazyImage
          className="p-2 lg:px-40 lg:pt-2"
          src={image.src}
          srcSet={image.srcSet}
          // px-20 on the wrapper plus lg:px-40 on the image itself.
          sizes="(min-width: 1024px) 60vw, 90vw"
          width={image.width}
          height={image.height}
          alt={image.alt}
          priority
        />
      </div>
    </Link>
  );
};

export default View;
